import React from "react";
import { Box } from "@mui/material";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import { CountryCode, MarketplaceService } from "../mockData/marketplaceMockData";
import {
  EB_DISCOUNT_PERCENT,
  formatMarketplacePrice,
  getEbPrice,
} from "../marketplacePricing";

interface Props {
  services: MarketplaceService[];
  about?: string;
  country?: CountryCode;
}

const VendorServicesList: React.FC<Props> = ({ services, about, country = "IN" }) => {
  return (
    <Box className="vendor_services_section">
      {about && <p className="vendor_about_text">{about}</p>}

      <Box className="eb_pricing_banner">
        <span className="eb_pricing_badge">
          <LocalOfferOutlinedIcon />
          {EB_DISCOUNT_PERCENT}% OFF
        </span>
        <p>Book via Employee Benefits — pay half the market price on services below.</p>
      </Box>

      <Box className="vendor_services_header">
        <h6>Services offered</h6>
        <span>{services.length} services</span>
      </Box>

      <Box className="vendor_services_grid">
        {services.map((service) => {
          const ebPrice = getEbPrice(service.mrp);

          return (
            <Box key={service.name} className="vendor_service_card">
              <Box className="vendor_service_top">
                <strong>{service.name}</strong>
                <Box className="vendor_service_pricing">
                  <span className="service_mrp">{formatMarketplacePrice(service.mrp, country)}</span>
                  <span className="service_eb_price">{formatMarketplacePrice(ebPrice, country)}</span>
                  <span className="service_eb_label">via EB</span>
                </Box>
              </Box>
              {service.description && <p>{service.description}</p>}
              <span className="service_unit">per {service.priceUnit}</span>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default VendorServicesList;
